module.exports = __webpack_public_path__ + "img/logo_mandiri_taspen.dd4634ae.png";